import { TableField } from "../../table-field";

const posicao: TableField = {
    key: "NrClassificacao",
    label: "Posição",
    tdClass: ["quebrarPorPalavra, text-center"],
    thClass: ["text-center"],
    sortable: true
}

const modalidade: TableField = {
    key: "IdTipoClassificadoNavigation.DsTipoClassificado",
    label: "Modalidade",
    tdClass: ["quebrarPorPalavra, text-center"],
    thClass: ["text-center"],
    sortable: true
}

const nome: TableField = {
    key: "NomeClassificado",
    label: "Nome",
    tdClass: ["quebrarPorPalavra, text-center"],
    thClass: ["text-center"],
    sortable: true
}

const cpf: TableField = {
    key: "CpfClassificado",
    label: "CPF",
    tdClass: ["quebrarPorPalavra, text-center"],
    thClass: ["text-center"],
    sortable: true
}

const actions: TableField = {
    key: "actions",
    label: "Ações",
    tdClass: ["quebrarPorPalavra, text-center"],
    thClass: ["text-center"],
}

export const fieldsTabelaClassificados: TableField[] = [
    posicao,
    modalidade,
    nome,
    cpf,
    actions
]